import { useLayoutEffect, useSyncExternalStore } from 'react';

import App from './App';

function readScheme(): 'light' | 'dark' {
  return document.documentElement.getAttribute('data-mantine-color-scheme') === 'dark'
    ? 'dark'
    : 'light';
}

function subscribeScheme(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-mantine-color-scheme'],
  });
  return () => observer.disconnect();
}

export function RefinedInkRoot() {
  const scheme = useSyncExternalStore(subscribeScheme, readScheme);

  useLayoutEffect(() => {
    document.documentElement.classList.add('ri');
    document.documentElement.setAttribute('data-theme', scheme);
  }, [scheme]);

  return (
    <div className="ri" data-theme={scheme}>
      <App />
    </div>
  );
}
